import { render } from "./AlertQR.vue?vue&type=template&id=483d9442"
import script from "./AlertQR.vue?vue&type=script&lang=js"
export * from "./AlertQR.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__